/* global $ */
import Vue from 'vue';

function detectMobile() {
  return window.innerWidth < 768;
}

function detectTablet() {
  return window.innerWidth < 1051 && window.innerWidth >= 768;
}

const deviceInfo = Vue.observable({
  isMobile: detectMobile(),
  isTablet: detectTablet(),
});

export default {
  isMobile: () => deviceInfo.isMobile,
  isTablet: () => deviceInfo.isTablet,
};

((window) => {
  if (window) {
    $(window).resize(() => {
      deviceInfo.isMobile = detectMobile();
      deviceInfo.isTablet = detectTablet();
    });
    //    $(window).on('orientationchange', detectMobile);
  }
})(window);
